import { Controller } from "@hotwired/stimulus"

// O preview de destaque do passo ④ do assistente (Admin::Posts::HighlightPreviewsController). A
// conta é do servidor, com os campos que a mudam — destaque, categoria e data do evento — lidos do
// form como estão agora. Fica no form, e não no frame, porque a categoria e a data estão na etapa ②.
//
// O frame é lazy: enquanto o passo ④ está escondido, trocar o src só guarda a URL, e ele carrega
// quando aparece. Depois do primeiro carregamento, cada src novo busca na hora.
const FIELDS = ["post[featured]", "post[category_id]", "post[event_starts_at]"]

export default class extends Controller {
  static targets = ["frame"]
  static values = { url: String }

  connect() {
    this.refresh()
  }

  refresh() {
    if (!this.hasFrameTarget) return

    // O checkbox manda o "0" do hidden e, marcado, o "1" depois; vale o último, como no Rails. A
    // categoria travada (post no ar) é um select desabilitado e não entra no FormData.
    const data = new FormData(this.element)
    const url = new URL(this.urlValue, window.location.href)
    FIELDS.forEach((name) => {
      const value = data.getAll(name).pop()
      if (value !== undefined) url.searchParams.set(name, value)
    })

    // Atribuir o mesmo src recarrega o frame, e o Turbo reescreve o atributo com a URL absoluta.
    const current = this.frameTarget.getAttribute("src")
    if (current && new URL(current, window.location.href).href === url.href) return

    this.frameTarget.src = url.href
  }
}
